define('BayEngageReviews.Body.View', [
    'bay_engage_reviews_body.tpl',
    'Backbone',
    'jQuery'
], function (
    bay_engage_reviews_body_tpl,
    Backbone,
    jQuery
) {
    'use strict';

    return Backbone.View.extend({
        template: bay_engage_reviews_body_tpl,

        initialize: function (options) {
            this.payload = options.payload || {};
            this.config = options.config || {};
            this.loader = options.loader;
        },

        afterRender: function () {
            // Ask the shared loader to inject the bundle. Other views will
            // make the same request; the loader coalesces them into one injection.
            if (this.loader && this.payload) {
                this.loader.load(this.payload, {
                    debugMode: this.config.debugMode,
                    containerId: this.config.containerId
                });
            }
        },

        destroy: function () {
            if (Backbone.View.prototype.destroy) {
                Backbone.View.prototype.destroy.apply(this, arguments);
            } else if (Backbone.View.prototype.remove) {
                Backbone.View.prototype.remove.apply(this, arguments);
            }
        }
    });
});
